/* unplugin-vue-components disabled */import i18n from '@/lang';
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.array.join.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.array.join.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ImgUpload from '@/components/ImgUpload';
import Popup from "vux/src/components/popup/index.vue"; // this line is trasformed by vux-loader
import ViewBox from "vux/src/components/view-box/index.vue"; // this line is trasformed by vux-loader
import Cell from "vux/src/components/cell/index.vue"; // this line is trasformed by vux-loader
import Group from "vux/src/components/group/index.vue"; // this line is trasformed by vux-loader
import CellBox from "vux/src/components/cell-box/index.vue"; // this line is trasformed by vux-loader
import XButton from "vux/src/components/x-button/index.vue"; // this line is trasformed by vux-loader
import XTextarea from "vux/src/components/x-textarea/index.vue"; // this line is trasformed by vux-loader
import XSwitch from "vux/src/components/x-switch/index.vue"; // this line is trasformed by vux-loader
import { apimessage } from '@/api';
export default {
  props: {
    value: {
      type: Boolean,
      required: false
    },
    oid: String
  },
  components: {
    Popup: Popup,
    ViewBox: ViewBox,
    Cell: Cell,
    Group: Group,
    CellBox: CellBox,
    XButton: XButton,
    XTextarea: XTextarea,
    ImgUpload: ImgUpload,
    XSwitch: XSwitch
  },
  watch: {
    value: function value(val) {
      this.messageShow = val;
    },
    messageShow: function messageShow(val) {
      var _this = this;
      if (val) {
        this.$setLeft({
          control: true,
          onSuccess: function onSuccess() {
            _this.messageShow = false;
          }
        });
      } else {
        this.messageFields = {
          message: '',
          imgList: [],
          attachmentList: [],
          isCustomerView: false
        };
        this.$setLeft({
          control: false
        });
      }
      this.$emit('input', val);
    }
  },
  data: function data() {
    return {
      loading: false,
      messageShow: this.value,
      // 工单留言表单字段
      messageFields: {
        message: '',
        imgList: [],
        attachmentList: [],
        isCustomerView: false
      }
    };
  },
  methods: {
    checkmessage: function checkmessage() {
      if (this.trim(this.messageFields.message) === '') {
        this.$vux.toast.text(i18n.tc("688"));
      }
    },
    trim: function trim(str) {
      return str.replace(/^(\s|\u00A0)+/, '').replace(/(\s|\u00A0)+$/, '');
    },
    submit: function submit() {
      var _this2 = this;
      if (this.trim(this.messageFields.message) !== '') {
        this.loading = true;
        apimessage({
          oid: this.oid,
          content: this.messageFields.message,
          images: this.messageFields.imgList.join(','),
          fileUrl: this.messageFields.attachmentList.join(',')
        }).then(function (res) {
          _this2.loading = false;
          if (res.success) {
            _this2.$vux.toast.text(i18n.tc("338"));
            _this2.messageShow = false;
            _this2.$emit('on-success');
          } else {
            _this2.$vux.toast.text(res.message);
          }
        });
      } else {
        this.$vux.toast.text(i18n.tc("688"));
      }
    }
  },
  creatad: function creatad() {}
};